<template>
  <v-autocomplete
    :items="types_expertise"
    item-text="description"
    data-test="appraisal-select"
    item-value="is_traditional_appraisal"
    @change="handleSelect"
    :loading="loading"
    :value="appraisal"
    :label="label"
    :required="required"
    :error-messages="errorMessages"
    return-object
    :disabled="loading"
  >
    <template v-slot:item="{ item }">
      <v-list-item-content
        class="v-list-item__content"
        data-test="appraisal-select-item"
      >
        <v-list-item-title v-text="item.description"></v-list-item-title>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import i18n from "@/mixins/i18n";
import { getAppraisals } from "@/services/appraisals";

export default {
  name: "select-appraisal",
  mixins: [i18n],
  props: {
    appraisal: Boolean,
    label: String,
    clearable: Boolean,
    errorMessages: [String, Array],
    required: Boolean,
  },
  model: {
    prop: "appraisal",
    event: "change",
  },
  data: () => ({
    types_expertise: [],
    loading: false,
  }),
  methods: {
    async fetchAppraisals() {
      this.loading = true;
      this.types_expertise = await getAppraisals();
      this.loading = false;
    },

    handleSelect(value) {
      this.$emit("change", value);
    },
  },
  created() {
    this.fetchAppraisals();
  },
};
</script>
